// File: frontend/src/i18n/shell.js
// Version: 1.0 (2026-10-16, Wave 1 Translation — Shell)
// Description: Словарь общей оболочки (FitenkoRail, FitenkoVerhnyayaPanel, FitenkoPochta).
//              Соблюдает строгий паритет ключей EN/RU.

const EN = {
    // ── Rail ──────────────────────────────────────────────────────────────────
    'shell.rail.mark': 'OS OFFICE LAW',
    'shell.rail.group.home': 'HOME',
    'shell.rail.group.work': 'WORK',
    'shell.rail.group.practice': 'PRACTICE',
    'shell.rail.group.growth': 'AI & GROWTH',
    'shell.section.today': 'Today',
    'shell.section.calendar': 'Calendar',
    'shell.section.inbox': 'Inbox',
    'shell.section.clients': 'Leads',
    'shell.section.cases': 'Cases',
    'shell.section.history': 'History',
    'shell.section.ai_ops': 'AI Operations',
    'shell.section.growth': 'Growth Center',
    'shell.section.blog': 'Blog',
    'shell.section.settings': 'Settings',

    // ── Subnav & Legacy Destinations ─────────────────────────────────────────
    'shell.dest.dashboard': 'Dashboard',
    'shell.dest.cases': 'Cases',
    'shell.dest.leads': 'Leads',
    'shell.dest.email_inbox': 'Email Inbox',
    'shell.dest.calendar': 'Calendar',
    'shell.dest.tasks': 'Tasks',
    'shell.dest.client_portal': 'My Portal',
    'shell.dest.ai_paralegal': 'AI Paralegal',
    'shell.dest.voice_ai': 'Voice AI',
    'shell.dest.ai_staff': 'AI Staff',
    'shell.dest.brain_center': 'Brain Center',
    'shell.dest.reputation': 'Reputation',
    'shell.dest.organic_seo': 'Organic SEO',
    'shell.dest.seo_analytics': 'SEO Analytics',
    'shell.dest.billing': 'Billing',
    'shell.dest.doc_generator': 'Doc Generator',
    'shell.dest.magic_deploy': 'Magic Deploy',
    'shell.dest.users': 'Users',
    'shell.dest.audit_log': 'Audit Log',
    'shell.dest.company_profile': 'Company Profile',
    'shell.dest.profile': 'Profile',
    'shell.dest.history': 'History',
    'shell.dest.inbox': 'Inbox',
    'shell.dest.ai_ops': 'AI Operations',
    'shell.dest.blog': 'Blog',

    // ── Legacy Groups ────────────────────────────────────────────────────────
    'shell.group.business': 'Business',
    'shell.group.ai': 'AI Operations',
    'shell.group.growth': 'Marketing & SEO',
    'shell.group.tools': 'Tools',
    'shell.group.admin': 'Admin',

    // ── User Roles ───────────────────────────────────────────────────────────
    'shell.role.Creator': 'Creator',
    'shell.role.Super Admin': 'Super Admin',
    'shell.role.Partner': 'Partner',
    'shell.role.Admin': 'Admin',
    'shell.role.Attorney': 'Attorney',
    'shell.role.Paralegal': 'Paralegal',
    'shell.role.Client': 'Client',
    'shell.role.User': 'User',

    // ── Верхняя панель: выбор офиса ───────────────────────────────────────────
    'shell.office.failed': 'offices could not be read',
    'shell.office.not_received': 'offices not received',
    'shell.office.main': 'main',
    'shell.office.branch': 'branch',
    'shell.office.firm': 'Firm',
    'shell.office.address': 'Address',
    'shell.office.phone': 'Phone',
    'shell.office.email': 'Email',
    'shell.office.hours': 'Hours',
    'shell.office.languages': 'Languages',
    'shell.office.public_allowed': 'street address may be published',
    'shell.office.public_forbidden': 'street address must NOT be published — residential location',

    // ── Верхняя панель: поиск ─────────────────────────────────────────────────
    'shell.search.placeholder': 'Name, email, phone, or case number',
    'shell.search.aria_label': 'Search leads, people, and cases',
    'shell.search.open': 'Open search',
    'shell.search.close': 'Close search',
    'shell.search.clear': 'Clear',
    'shell.search.searching': 'searching…',
    'shell.search.forbidden': 'search across people and cases is available to firm staff only',
    'shell.search.not_responded': 'search did not respond',
    'shell.search.failed': 'Search did not respond: {text}',
    'shell.search.no_results': 'No results found.',
    'shell.search.people': 'People',
    'shell.search.cases': 'Cases',
    'shell.search.not_all_shown': ' — not all shown',
    'shell.search.unnamed': '— unnamed —',
    'shell.search.leads_count.one': ' · {count} lead',
    'shell.search.leads_count.few': ' · {count} leads',
    'shell.search.leads_count.many': ' · {count} leads',
    'shell.search.has_account': ' · has user account',
    'shell.search.duplicate_merged': ' · duplicate, merged',
    'shell.search.scope_searching': 'Searching: {list}.',
    'shell.search.scope_not_searching': 'Not searching: {list}.',

    // ── Верхняя панель: Ask AI ────────────────────────────────────────────────
    'shell.ask_ai': 'Ask {name}',

    // ── Экран почты (FitenkoPochta) ───────────────────────────────────────────
    'shell.mail.back': '← Back to work',
    'shell.mail.badge': 'INBOX',
    'shell.mail.title': 'Email Inbox',
    'shell.mail.subtitle': 'AI-reviewed client emails awaiting your approval.',
    'shell.mail.loading': 'Loading emails...',
    'shell.mail.empty': 'No emails awaiting review.',
    'shell.mail.forwarding_not_configured': '0 client emails, forwarding from info@ is not configured',
    'shell.mail.spam_notice': 'Emails classified as spam by Gmail in info@ do not appear here — check the Spam folder in info@',
    'shell.mail.not_connected': 'Mail not connected.',
    'shell.mail.toast_approved': 'Reply approved and sent.',
    'shell.mail.toast_dismissed': 'Email dismissed.',
    'shell.mail.toast_send_failed': 'Failed to send reply: {error}',
    'shell.mail.toast_dismiss_failed': 'Failed to dismiss: {error}',
    'shell.mail.toast_load_failed': 'Failed to load emails: {error}',
    'shell.mail.no_subject': '(no subject)',
    'shell.mail.ai_summary': 'AI Summary',
    'shell.mail.proposed_reply': 'Proposed reply (editable)',
    'shell.mail.placeholder': 'Write or edit the reply before sending...',
    'shell.mail.dismiss': 'Dismiss',
    'shell.mail.working': 'Working...',
    'shell.mail.sending': 'Sending...',
    'shell.mail.approve': 'Approve & Send',
    'shell.mail.chip_visa': 'Visa',
    'shell.mail.chip_urgency': 'Urgency',
    'shell.mail.chip_language': 'Language',
    'shell.mail.chip_phone': 'Phone',
    'shell.mail.mismatched_client_email': 'Warning: AI detected email {extracted} in message text, but reply will be sent strictly to sender address ({sendingTo})',
    'shell.auth.logout': 'Logout',
    'voice.kicker': 'Autonomous Voice Operations',
    'voice.title': 'AI Voice Operations',
    'voice.subtitle': 'Autonomous legal intake, call handling, live monitoring & sentiment analytics',
};

const RU = {
    // ── Rail ──────────────────────────────────────────────────────────────────
    'shell.rail.mark': 'OS OFFICE LAW',
    'shell.rail.group.home': 'ГЛАВНОЕ',
    'shell.rail.group.work': 'РАБОТА',
    'shell.rail.group.practice': 'ПРАКТИКА',
    'shell.rail.group.growth': 'AI И РОСТ',
    'shell.section.today': 'Сегодня',
    'shell.section.calendar': 'Календарь',
    'shell.section.inbox': 'Почта',
    'shell.section.clients': 'Обращения',
    'shell.section.cases': 'Дела',
    'shell.section.history': 'История',
    'shell.section.ai_ops': 'AI Операции',
    'shell.section.growth': 'Центр роста',
    'shell.section.blog': 'Блог',
    'shell.section.settings': 'Настройки',

    // ── Subnav & Legacy Destinations ─────────────────────────────────────────
    'shell.dest.dashboard': 'Главная',
    'shell.dest.cases': 'Дела',
    'shell.dest.leads': 'Обращения',
    'shell.dest.email_inbox': 'Входящие',
    'shell.dest.calendar': 'Календарь',
    'shell.dest.tasks': 'Задачи',
    'shell.dest.client_portal': 'Портал клиента',
    'shell.dest.ai_paralegal': 'AI Паралигал',
    'shell.dest.voice_ai': 'Голосовой AI',
    'shell.dest.ai_staff': 'AI Сотрудники',
    'shell.dest.brain_center': 'Центр управления',
    'shell.dest.reputation': 'Репутация',
    'shell.dest.organic_seo': 'SEO',
    'shell.dest.seo_analytics': 'SEO Аналитика',
    'shell.dest.billing': 'Оплата',
    'shell.dest.doc_generator': 'Генератор документов',
    'shell.dest.magic_deploy': 'Magic Deploy',
    'shell.dest.users': 'Сотрудники',
    'shell.dest.audit_log': 'Журнал аудита',
    'shell.dest.company_profile': 'Профиль компании',
    'shell.dest.profile': 'Профиль',
    'shell.dest.history': 'История',
    'shell.dest.inbox': 'Почта',
    'shell.dest.ai_ops': 'AI Операции',
    'shell.dest.blog': 'Блог',

    // ── Legacy Groups ────────────────────────────────────────────────────────
    'shell.group.business': 'Дела и клиенты',
    'shell.group.ai': 'Искусственный интеллект',
    'shell.group.growth': 'Маркетинг и рост',
    'shell.group.tools': 'Инструменты',
    'shell.group.admin': 'Управление',

    // ── User Roles ───────────────────────────────────────────────────────────
    'shell.role.Creator': 'Создатель',
    'shell.role.Super Admin': 'Суперадмин',
    'shell.role.Partner': 'Партнёр',
    'shell.role.Admin': 'Администратор',
    'shell.role.Attorney': 'Адвокат',
    'shell.role.Paralegal': 'Паралигал',
    'shell.role.Client': 'Клиент',
    'shell.role.User': 'Пользователь',

    // ── Верхняя панель: выбор офиса ───────────────────────────────────────────
    'shell.office.failed': 'офисы не прочитаны',
    'shell.office.not_received': 'офисы не пришли',
    'shell.office.main': 'главный',
    'shell.office.branch': 'филиал',
    'shell.office.firm': 'Фирма',
    'shell.office.address': 'Адрес',
    'shell.office.phone': 'Телефон',
    'shell.office.email': 'Почта',
    'shell.office.hours': 'Часы',
    'shell.office.languages': 'Языки',
    'shell.office.public_allowed': 'улицу публиковать можно',
    'shell.office.public_forbidden': 'улицу публиковать НЕЛЬЗЯ — это жильё',

    // ── Верхняя панель: поиск ─────────────────────────────────────────────────
    'shell.search.placeholder': 'Имя, почта, телефон или номер дела',
    'shell.search.aria_label': 'Поиск по обращениям, людям и делам',
    'shell.search.open': 'Открыть поиск',
    'shell.search.close': 'Закрыть поиск',
    'shell.search.clear': 'Очистить',
    'shell.search.searching': 'ищем…',
    'shell.search.forbidden': 'поиск по людям и делам доступен только сотрудникам фирмы',
    'shell.search.not_responded': 'поиск не ответил',
    'shell.search.failed': 'Поиск не ответил: {text}',
    'shell.search.no_results': 'Ничего не нашлось.',
    'shell.search.people': 'Люди',
    'shell.search.cases': 'Дела',
    'shell.search.not_all_shown': ' — показаны не все',
    'shell.search.unnamed': '— без имени —',
    'shell.search.leads_count.one': ' · обращений {count}',
    'shell.search.leads_count.few': ' · обращений {count}',
    'shell.search.leads_count.many': ' · обращений {count}',
    'shell.search.has_account': ' · есть учётная запись',
    'shell.search.duplicate_merged': ' · дубль, объединён',
    'shell.search.scope_searching': 'Ищем: {list}.',
    'shell.search.scope_not_searching': 'Не ищем: {list}.',

    // ── Верхняя панель: Ask AI ────────────────────────────────────────────────
    'shell.ask_ai': 'Спросить {name}',

    // ── Экран почты (FitenkoPochta) ───────────────────────────────────────────
    'shell.mail.back': '← Назад к работе',
    'shell.mail.badge': 'ВХОДЯЩИЕ',
    'shell.mail.title': 'Email Inbox',
    'shell.mail.subtitle': 'Письма клиентов, проверенные ИИ и ожидающие вашего решения.',
    'shell.mail.loading': 'Загрузка писем...',
    'shell.mail.empty': 'Нет писем, ожидающих решения.',
    'shell.mail.forwarding_not_configured': '0 писем клиентов, пересылка с info@ не настроена',
    'shell.mail.spam_notice': 'Письма, которые Gmail отнёс к спаму в info@, сюда не попадают — проверяйте папку «Спам» info@',
    'shell.mail.not_connected': 'Почта не подключена.',
    'shell.mail.toast_approved': 'Ответ одобрен и отправлен.',
    'shell.mail.toast_dismissed': 'Письмо отклонено.',
    'shell.mail.toast_send_failed': 'Не удалось отправить ответ: {error}',
    'shell.mail.toast_dismiss_failed': 'Не удалось отклонить: {error}',
    'shell.mail.toast_load_failed': 'Не удалось загрузить письма: {error}',
    'shell.mail.no_subject': '(без темы)',
    'shell.mail.ai_summary': 'Сводка ИИ',
    'shell.mail.proposed_reply': 'Предложенный ответ (можно редактировать)',
    'shell.mail.placeholder': 'Напишите или отредактируйте ответ перед отправкой...',
    'shell.mail.dismiss': 'Отклонить',
    'shell.mail.working': 'Обработка...',
    'shell.mail.sending': 'Отправка...',
    'shell.mail.approve': 'Одобрить и отправить',
    'shell.mail.chip_visa': 'Виза',
    'shell.mail.chip_urgency': 'Срочность',
    'shell.mail.chip_language': 'Язык',
    'shell.mail.chip_phone': 'Телефон',
    'shell.mail.mismatched_client_email': 'Внимание: ИИ обнаружил в тексте письма адрес {extracted}, но ответ будет отправлен строго на адрес отправителя ({sendingTo})',
    'shell.auth.logout': 'Выйти',
    'voice.kicker': 'Автономные голосовые операции',
    'voice.title': 'Голосовые ИИ-операции',
    'voice.subtitle': 'Автономный прием обращений, обработка звонков, живой мониторинг и анализ тональности',
};

export const SLOVAR = Object.freeze({
    en: Object.freeze(EN),
    ru: Object.freeze(RU),
});

export function pluralCategory(lang, n) {
    const num = Math.abs(Number(n) || 0);
    if (lang === 'ru') {
        const rem100 = num % 100;
        const rem10 = num % 10;
        if (rem100 >= 11 && rem100 <= 14) return 'many';
        if (rem10 === 1) return 'one';
        if (rem10 >= 2 && rem10 <= 4) return 'few';
        return 'many';
    }
    return num === 1 ? 'one' : 'many';
}

export function sklonit(lang, baseKey, count, vars = {}) {
    const cat = pluralCategory(lang, count);
    const key = `${baseKey}.${cat}`;
    return perevesti(lang, key, { ...vars, count });
}

export function perevesti(lang, key, vars) {
    const yazyk = lang === 'ru' ? 'ru' : 'en';
    const slovar = SLOVAR[yazyk];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) {
        return `[${key}]`;
    }
    const shablon = slovar[key];
    const peremennye = vars && typeof vars === 'object' ? vars : {};
    return shablon.replace(/\{([a-zA-Z_]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(peremennye, imya) &&
        peremennye[imya] !== undefined &&
        peremennye[imya] !== null
            ? String(peremennye[imya])
            : '—'
    ));
}

export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
